<template>
    <div
        class="sticky"
        :style="[
            {
                position: !ignore ? 'sticky' : '',
                top: top + 'px',
            },
            scrollTop >= top ? stickyStyle : style,
        ]"
        v-show="scrollTop >= show || stickyShowBefore"
    >
        <div
            :class="
                scrollTop >= (show !== '' ? show : top) ? stickyClass : Class
            "
        >
            <!-- <div>
          isShow: {{ show }}. isTop: {{ top }}. {{ scrollTop   }} >= {{ (show !== '' ? show : top) }}, {{ scrollTop >= (show !== '' ? show : top)  ? stickyClass : Class }}
        </div> -->
            <!-- <div style="position: absolute; left: 60px">
                {{ scrollTop }} {{ show }}
            </div> -->
            <slot name="default" />
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "Sticky",
    data() {
        return {
            disableSticky: false,
            interval: "",
        };
    },
    props: {
        top: {
            type: Number,
            default: 0,
        },
        show: {
            type: [Number, String],
            default: "",
        },
        sticky: {
            type: Boolean,
            default: true,
        },
        zIndex: {
            type: String,
        },
        style: {
            type: [String, Object],
        },
        stickyStyle: {
            type: [Object, String],
        },
        Class: {
            type: String,
        },
        stickyClass: {
            type: String,
        },
        stickyShowBefore: {
            type: Boolean,
            default: true,
        },
        ignore: {
            type: Boolean,
        },
    },
    computed: {
        ...mapState(["scrollTop", "isMobile"]),
    },
    watch: {
        $route(newVal) {
            this.checking();
        },
    },
    mounted() {
        this.checking();
    },
    unmounted() {
        clearInterval(this.interval);
    },
    methods: {
        clear() {
            clearInterval(this.interval);
            this.interval = "";
        },
        checking(index) {
            if (this.interval !== "") {
                this.clear();
            }
            let count = 0;
            let maxRun = 10;

            this.interval = setInterval(() => {
                count++;
                let deviceHeight = window.outerHeight;
                let webpageHeight = document.documentElement.scrollHeight;
                if (webpageHeight > deviceHeight + 100) {
                    this.disableSticky = true;
                } else {
                    this.disableSticky = false;
                }

                if (count >= maxRun) {
                    this.clear();
                }
            }, 1000);
        },
    },
};
</script>

<style scoped>
.sticky {
    /* position: sticky; */
    z-index: 9;
}
</style>
